export default {
  'footer.text': 'Developed with science and curiosity!',
  'footer.copyright':
    'COPYRIGHT © {year}<examod> Examod, </examod>All rights reserved |<terms> Terms and Conditions</terms><privacy> | Privacy Policy</privacy><about> | About</about>',
};  
